import { IconTimeline } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import { defaultTimelineConfig } from '../../mermaid/timelineUtils';
import { TimelineBlockView, type TimelineData } from './TimelineBlockView';

export const timelinePlugin: BlockPlugin<TimelineData> = {
    name: 'timeline',
    displayName: 'Timeline',
    hasData: true,
    defaultData: {
        mode: 'auto' as const,
        config: defaultTimelineConfig,
        manualChart: undefined,
        autoChart: undefined
    },
    Component: TimelineBlockView,
    toolbarInsert: {
        icon: <IconTimeline size={16} />,
        title: 'Timeline',
        description: 'Add project timeline',
        category: 'component'
    }
};

registerBlockPlugin(timelinePlugin);
